module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = ./node_modules/react-phone-number-input/node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js
// module chunks = 0 1 2